import { Money04Icon } from "@hugeicons-pro/core-stroke-rounded";
import { BoomFinanceVerificationSettings } from "shared/types";
import { Show } from "shared/components";
import { formatToCurrency } from "shared/utils/currency";
import { Section } from "views/applications-id-report/components/Section";
import { Row } from "views/applications-id-report/components/Row";
import { SectionIcon } from "../components/SectionIcon";
import { PurchaseInfo } from "../types";
import { formatLabel, isFieldVisible, isStepVisible } from "../utils";

export const LoanDetailsSlice = ({
  loan,
  settings
}: {
  loan: PurchaseInfo;
  settings?: BoomFinanceVerificationSettings["loan_details"];
}) => {
  const hasCapturedData = Boolean(
    loan.loanProgram || loan.purchasePrice || loan.downPaymentAmount
  );
  const showPurchasePrice = isFieldVisible(
    loan.purchasePrice,
    settings?.purchase_price
  );
  const showDownPayment = isFieldVisible(
    loan.downPaymentAmount,
    settings?.down_payment_amount
  );

  if (!isStepVisible(settings) && !hasCapturedData) return null;

  return (
    <Section
      sectionTitle="Loan details"
      icon={<SectionIcon icon={Money04Icon} />}
    >
      <div className="space-y-2">
        <Show if={showPurchasePrice}>
          <Row
            title="Purchase price"
            value={formatToCurrency(loan.purchasePrice)}
          />
        </Show>
        <Show if={showDownPayment}>
          <Row
            title="Down payment"
            value={formatToCurrency(loan.downPaymentAmount)}
          />
        </Show>
        <Show if={showPurchasePrice && showDownPayment}>
          <Row title="Loan amount" value={formatToCurrency(loan.loanAmount)} />
        </Show>
        <Show if={Boolean(loan.loanProgram)}>
          <Row title="Loan program" value={formatLabel(loan.loanProgram)} />
        </Show>
      </div>
    </Section>
  );
};
